export default {
  loading: false,
  error: false,
  getDashboardDataStatus: { data: null },
};
